// Dollar Prices Mutations

export const updateDollarPricesList = (state, payload) => {
  state.dollarPricesList = payload
}

export const setLastDollarPrice = (state, payload) => {
  state.lastDollarPrice = payload
}

export const setDollarPriceInfo = (state, payload) => {
  state.dollarPriceInfo = payload
}
